import { render, staticRenderFns } from "./EditMailingListDialog.vue?vue&type=template&id=17491d1a&"
import script from "./EditMailingListDialog.vue?vue&type=script&lang=js&"
export * from "./EditMailingListDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports